module.exports=function(scope){ return `// Configure where the FaceTec SDK looks for custom localizaed strings.
// @param - table - (Optional) Name of the string table to look in.  By default, this is "Zoom" and string will be read from Zoom.strings
// @param - bundle - (Optional) NSBundle instance to search for Zoom string definitions in.  This will be searched after the main bundle and before Zoom's default strings
//
[Zoom.sdk configureLocalizationWithTable:table bundle:bundle];
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/configure-localization.m.tpl